<div class="call-filter__root">
  <div class="filters-header bottom-spacing">
    <span class="headline"> Filters </span>
    <button mat-icon-button style="color: #6A6A6A;" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="input-container bottom-spacing">
    <mat-label class="section-label">Search</mat-label>
    <mat-form-field appearance="fill">
      <mat-label>Name or contact number</mat-label>
      <input matInput placeholder="Ex. John Doe" [formControl]="nameOrNumber">
    </mat-form-field>
  </div>
  <div *ngIf="type==='call'" class="input-container bottom-spacing">
    <mat-label class="section-label">Call Duration</mat-label>
    <div class=" medium-size">
      <mat-form-field [formGroup]="duration" appearance="fill">
        <mat-label>Write the time</mat-label>
        <input formControlName="min" class="right-separation" matInput placeholder="Ex. 02m:15s" mask="m0L:s0L" [leadZeroDateTime]="true" (keyup)="onKey($event, 'min')">
        <mat-error> Incorrect duration format correct example 0:15</mat-error>
      </mat-form-field>
      <mat-form-field [formGroup]="duration" appearance="fill">
        <mat-label>Write the time</mat-label>
        <input formControlName="max" matInput placeholder="Ex. 02m:15s" mask="m0L:s0L" [leadZeroDateTime]="true" (keyup)="onKey($event, 'max')">
        <mat-error> Incorrect duration format correct example 0:15</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="checkbox-container bottom-spacing" style="padding-top: 8px" [formGroup]="status">
    <mat-label class="section-label">Call Status</mat-label>
    <mat-checkbox *ngIf="type === 'call'" [value]="'initiated'" formControlName="initiated" >Initiated</mat-checkbox>
    <mat-checkbox *ngIf="type === 'call'" [value]="'successful'" formControlName="successful" >Successful</mat-checkbox>
    <mat-checkbox *ngIf="type === 'call'" [value]="'missed'" formControlName="missed" >Missed</mat-checkbox>
    <mat-checkbox *ngIf="type === 'call'" [value]="'error'" formControlName="error">Error</mat-checkbox>
    <mat-checkbox *ngIf="type === 'message'" [value]="'delivered'" formControlName="delivered" >Delivered</mat-checkbox>
    <mat-checkbox *ngIf="type === 'message'" [value]="'undelivered'" formControlName="undelivered">Undelivered</mat-checkbox>
  </div>
  <div class="input-container bottom-spacing" style="padding-top: 16px">
    <mat-label class="section-label">Enter a date range</mat-label>
    <mat-form-field appearance="fill">
      <mat-label>Enter a date range</mat-label>
      <mat-date-range-input [formGroup]="dateRange" [rangePicker]="picker">
        <input matStartDate formControlName="start" placeholder="Start date" [readOnly]="true">
        <input matEndDate formControlName="end" placeholder="End date" [readOnly]="true">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
      <mat-error *ngIf="dateRange.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
      <mat-error *ngIf="dateRange.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
    </mat-form-field>
  </div>
  <div class="filters-buttons-container">
    <button mat-button style="margin-right: 16px" (click)="reset()"> Reset </button>
    <button mat-raised-button color="primary" (click)="apply()"> Apply </button>
  </div>
</div>
